<template>
    <v-row>
        <v-col>
            <v-text-field v-model="labelText" label="Label" @change="emit"/>
            <span class="body-2 text--secondary">The label to be used next to the switch.</span>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "SwitchComp",
    data: () => ({
        labelText: ''
    }),
    methods: {
        emit(){
            let opts = {
                type: 'switch'
            };
            if(this.labelText != '') {
                opts.label = this.labelText;
            }

            this.$emit('change', opts);
        }
    },
    created() {
        this.emit();
    }
}
</script>